export const updateState = 'UPDATE_ANALYTICS';
export const updateStateConstant = 'UPDATE_STATE';
export const setOwnerName = 'SET_OWNER_NAME';
export const setOwnerCell = 'SET_OWNER_CELL';
